const BBoxIndex = () => import(/* webpackChunkName: "box-index" */ '@/modules/box/home');
const BBoxInfo = () => import(/* webpackChunkName: "box-info" */ '@/modules/box/info');

//SideBar
const SideBarBox = () =>
    import(/* webpackChunkName: "SideBarBox" */ '@/components/layouts/side-bar/the-side-bar-box');

/*
 *  Add noHeader in meta if you don't need header
 *  Add noStepBack in meta if you don't need arrow back
 * */

export default [
    {
        path: '/box/:id',
        name: 'home-box',
        meta: {
            layout: 'link',
            noStepBack: true,
        },
        components: {
            default: BBoxInfo,
            sidebar: SideBarBox,
        },
    },
    {
        path: '/box/:id/info',
        name: 'info',
        meta: {
            layout: 'link',
            noStepBack: true,
            page_class: 'page-info',
        },
        components: {
            default: BBoxInfo,
            sidebar: SideBarBox,
        },
    },
];
